module.exports = __webpack_public_path__ + "assets/img/download-on-the-app-store.57035229.png";